import { useState, useEffect } from 'react'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import s from './LostOpportunityModal.scss'
import { fromAwardedCompanies } from 'utils/serializers'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toCompaniesSelect } from 'components/Companies/serializers'
import { FcBadDecision } from 'react-icons/fc'
import { makeGetRequest } from 'utils/api'
import Select from 'react-select'
import { toCategories } from './serializers'

const LostOpportunityModal = ({
  showLostOpportunityModal,
  toggleLostOpportunityModal,
  entity,
  onSave,
  cancelCb,
  status,
  reasons: dealReasons
}) => {
  const [dealAwarded, setDealAwarded] = useState(
    entity.awardedCompany || (status === 'NN' ? false : true)
  )
  const [awardedCompany, setAwardedCompany] = useState(
    entity.awardedCompany
      ? entity.awardedCompany?.value
        ? entity.awardedCompany
        : fromAwardedCompanies(entity.awardedCompany)
      : entity.dealCompanies?.length === 1
        ? entity.dealCompanies[0].company
          ? fromAwardedCompanies(entity.dealCompanies[0].company)
          : entity.dealCompanies[0]
        : null
  )
  const [bidStatus, setBidStatus] = useState(
    status === 'NN' ? { value: 2, label: 'Bidding' } : { value: 3, label: 'Bidding Awarded' }
  )
  const [reasons, setReasons] = useState(dealReasons || [])
  const [reason, setReason] = useState(null)

  useEffect(() => {
    ;(async () => {
      if (reasons && reasons.length) return
      const response = await makeGetRequest('/v1/dealreason')
      setReasons(toCategories(response))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showLostOpportunityModal}
        toggle={toggleLostOpportunityModal}
      >
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <FcBadDecision className={s.partyIcon} />
            <h4 style={{ padding: '20px 0' }}>This opportunity will be closed as lost.</h4>
            {!entity.awardedCompany && status !== 'NN' && <p>Please set the awarded client.</p>}
          </div>
          {status !== 'NN' && (
            <div className={s.dealAwarded}>
              {!entity.awardedCompany && (
                <>
                  {status !== 'YN' && (
                    <>
                      Opportunity Awarded:
                      <input
                        type="radio"
                        checked={dealAwarded}
                        onChange={() => {
                          setDealAwarded(true)
                        }}
                      />{' '}
                      Yes
                      <input
                        type="radio"
                        checked={!dealAwarded}
                        onChange={() => {
                          setDealAwarded(false)
                          setAwardedCompany(null)
                          setBidStatus({ value: 2, label: 'Bidding' })
                        }}
                      />{' '}
                      No
                    </>
                  )}
                  {dealAwarded && (
                    <PaginatedSelect
                      url="/v1/companies"
                      className={s.clients}
                      value={awardedCompany}
                      onChange={value => {
                        setAwardedCompany(value)
                        setBidStatus({ value: 3, label: 'Bidding Awarded' })
                      }}
                      serializer={toCompaniesSelect}
                    />
                  )}
                </>
              )}
            </div>
          )}
          <p style={{ textAlign: 'center', marginTop: 30 }}>
            Please select the reason for not winning this opportunity
          </p>
          <Select onChange={setReason} options={reasons} value={reason} />
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            disabled={(status === 'YN' && !awardedCompany) || !reason}
            onClick={() =>
              onSave({
                awardedCompany: status === 'NN' ? null : awardedCompany,
                bidStatus,
                status,
                reason,
                isLostModal: true
              })
            }
          >
            Save
          </Button>
          <Button color="secondary" onClick={cancelCb}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default LostOpportunityModal
